export default __webpack_public_path__ + "static/media/pic4.b92b6d40.jpg";